import Cookie from 'js-cookie';

type TvNextCookie = {
    sharingSms?: boolean;
}

const fallbackFeatures: TvNextCookie = {};

export const getVNextFeatures = (): TvNextCookie => {
    try {
        const cookieName = CONFIG?.myPage?.vNext?.cookies?.features?.name;

        if (!cookieName) {
            throw new Error('vNext cookie name missing in config');
        }

        const vNextCookie = Cookie.get(cookieName);

        if (vNextCookie === undefined) return fallbackFeatures;

        const vNextCookieValue = JSON.parse(vNextCookie);
        const flags = vNextCookieValue.enabledFeatures as Partial<TvNextCookie>;

        return {};
    } catch (error) {
        return fallbackFeatures;
    }
};
